import { Divider } from 'antd';
import { SpecialSchedule } from '../location/hours/SpecialSchedule';

export const SpecialScheduleTab = ({ location}: any) => {
    return (            
        <SpecialSchedule location={location} />
    );
};